<script>
  import { onMount, createEventDispatcher } from "svelte";
  import { apiCall, getPagination, notify } from "../httpCommon";

  import DataTable, { Head, Body, Row, Cell } from "@smui/data-table";
  import IconButton, { Icon } from "@smui/icon-button";
  import Button from "@smui/button";
  import Select, { Option } from "@smui/select";
  import { exclude } from "@smui/common/exclude";

  import { stringify } from "query-string";
  import { PaginationNav } from "svelte-paginate";

  export let pageSizes = [10, 20, 50, 100];

  let DTProps = exclude($$props, ["pageSizes", "pageSize"]);
  const dispatch = createEventDispatcher();

  export let pagination;
  export let loading = false;

  function setPageSize(e) {
    const pageSize = parseInt(e.target.value);
    if (pagination.pageSize !== pageSize) {
      pagination.pageSize = pageSize;
      dispatch("setPage", pagination);
    }
  }

  function setPage(e) {
    const pageNo = parseInt(e.detail.page);
    if (pagination.pageNo !== pageNo) {
      pagination.pageNo = pageNo;
      dispatch("setPage", pagination);
    }
  }
</script>

<style>
  .pager {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .pager p {
    margin: 0;
  }

  :global(.data-table) {
    width: 100%;
  }
</style>

<DataTable class="data-table">
  <slot />
</DataTable>
{(console.log('pagination: ', pagination, 'loading: ', loading), '')}
<div class="pager">
  {#if pagination && pagination.count && (pagination.pageSize > pageSizes[0] || pagination.pageCount > 1)}
    <p>
      <Select value={pagination.pageSize} on:change={setPageSize}>
        {#each pageSizes as pSize}
          <Option value={pSize}>{pSize}</Option>
        {/each}
      </Select>
      {pagination.pageStart}-{pagination.pageEnd} of {pagination.count}
    </p>

    <PaginationNav
      totalItems={pagination.count}
      pageSize={pagination.pageSize}
      bind:currentPage={pagination.pageNo}
      limit={2}
      showStepOptions={true}
      on:setPage={setPage}>

      <span slot="prev">
        <Button disabled={loading || pagination.pageNo === 1}>
          <i class="material-icons">chevron_left</i>
        </Button>
      </span>
      <span slot="number" let:value={pageNumber}>
        <Button
          disabled={loading}
          variant={pageNumber === pagination.pageNo ? 'unelevated' : ''}>
          {pageNumber}
        </Button>
      </span>
      <span slot="next">
        <Button
          disabled={loading || pagination.pageCount === pagination.pageNo}>
          <i class="material-icons">chevron_right</i>
        </Button>
      </span>
      <span slot="ellipsis">
        <Button>...</Button>
      </span>

    </PaginationNav>
  {/if}
</div>
